import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-stock-detail-link a')

export default function StockDetailLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Stock Detail
      </a>
    )

  return (
    <a href={currentTimeframePath} className="tab-link font-semibold">
      Stock Detail
    </a>
  )
}
